import { createContext } from "react";

interface MobileNavContextType {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onToggle: () => void;
}

export const MobileNavContext = createContext<MobileNavContextType>({
  isOpen: false,
  onOpen: () => {},
  onClose: () => {},
  onToggle: () => {},
});